import React from "react";

const CartIcon = ({count=0  }) => {
  return (
    
    <>
      <span>{count}</span>
      <i className="ri-shopping-cart-2-fill cart-icon"></i>
    </>
    
  );
};

export default CartIcon;
